<template>
  <div>
      <div class="header-wrapper">
            Operaciones Concertadas
      </div>
      <vs-table v-if="concertedOperations.length > 0" :data="concertedOperations">        
      <template slot="thead">
        <vs-th>
          Id
        </vs-th>
        <vs-th>
          Fecha
        </vs-th>
        <vs-th>
          Cantidad de Animales
        </vs-th>
        <vs-th>
          Precio
        </vs-th>
        <vs-th>
          Admin que habilitó/deshabilitó
        </vs-th>
        <vs-th>
          Dashboard
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(operation,index) in data" >
          <vs-td :data="data[index].id">
            {{data[index].id}}
          </vs-td>

          <vs-td class="date-td" :data="data[index].created_at">
            {{formatDate(data[index].createdAt)}}
          </vs-td>
          <vs-td :data="data[index].quantity">
            {{data[index].quantity}}
          </vs-td>

          <vs-td :data="data[index].price">
            $/kg {{ data[index].price.toFixed(2).replace(".", ",")}}
          </vs-td>
          <vs-td :data="data[index].price">
            {{data[index].adminEmail || '-'}}
          </vs-td>
          <vs-td>
             <button v-if="operation.showInDashboard" class="btn btn--with-icon btn--small danger" @click="openPopup('disable',operation)">
              Deshabilitar
            </button>
            <button v-if="!operation.showInDashboard" class="btn btn--with-icon btn--small success" @click="openPopup('enable',operation)">
              Habilitar
            </button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup
            :title="this.popUpProps.title"
            :active.sync="confirmPopup"
            :button-close-hidden="true"
            class="confirm-action"
        >
            <div class="alert info">
                <vs-icon icon="warning"></vs-icon>
                <span
                    >{{this.popUpProps.text}}</span
                >
            </div>

            <div class="footer">
                <button @click="confirmPopup = false" class="btn cancel">
                    Cancelar
                </button>
                <button
                    class="btn confirm"
                    :class="{'btn--loading': buttonLoading }"
                    @click="
                        confirmAction()
                    "
                >
                    Continuar
                </button>
            </div>
        </vs-popup>

    <div
      v-if="concertedOperations.length === 0 && !isLoading"
      class="alert info"
    >
      <vs-icon icon="error"></vs-icon>
      No existen operaciones concretadas para esta oferta
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { print } from "graphql";
import concertedDashboardsByOffer from "../../graphql/queries/concertedDashboardsByOffer.gql";
import disableFromDashboard from "../../graphql/mutations/disableFromDashboard.gql";

export default {
  props: {
    offer: {
      type: Object,
    },
  },

  data() {
    return {
      buttonLoading: false,
      isLoading: true,
      concertedOperations: [],
      confirmPopup: false,
      popUpProps: {
        title:'',
        text:'',
        operation: null
      }
    };
  },

  mounted() {
    this.getConcertedOperations();
  },

  methods: {
    formatDate(operationDate) {
      let date = new Date(operationDate);
      let month = date.getMonth() + 1;
      if (month< 10 )
        month = `0${month}`
      return `${date.getDate()}/${month}/${date.getFullYear()}`
    },
    getConcertedOperations() {
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(concertedDashboardsByOffer),
            variables: {
              currentUserToken: localStorage.getItem("USER_TOKEN"),
              offerId: this.offer.id,
            },
          },
        })
        .then((res) => {
          if (res.data.errors) {
            isLoading = false;
            return;
          }
          this.concertedOperations = res.data.data.concertedDashboardsByOffer.sort((a,b)=> a.id - b.id);
          this.isLoading = false;
          this.confirmPopup = false;
          this.buttonLoading = false
        });
      return;
    },
    openPopup(popUpMode,operation) {
      this.popUpProps.operation = operation;
      if(popUpMode == 'enable') {
        this.popUpProps.title = 'Incluir operación en Dashboard';
        this.popUpProps.text = 'Al confirmar esta acción, la operación se incluirá en los cálculos de dashboard'
      }
      else {
        this.popUpProps.title = 'Ocultar operación en Dashboard';
        this.popUpProps.text = 'Al confirmar esta acción, la operación se excluirá de los cálculos de dashboard'
      }
        
      this.confirmPopup = true;
      

    },
    confirmAction() {
      this.buttonLoading = true;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(disableFromDashboard),
            variables: {
              currentUserToken: localStorage.getItem("USER_TOKEN"),
              offerId: this.popUpProps.operation.id,
              showInDashboard: !this.popUpProps.operation.showInDashboard,
            },
          },
        })
        .then((res) => {
          if (res.data.errors) {
            return;
          }
          this.getConcertedOperations();
        });
      return;
    }
  },
};
</script>
<style scoped>
  .btn--with{
    min-width: 100%
  }

  .date-td {
    min-width: 100px;
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: #F8F8F8;
    height: 70px;
    color: #42a26c ;
    font-size: 15px;
  }

  th {
    font-size: 15px;
    font-weight: normal ;
    border-bottom: 1px solid #bcbcbc;
    padding-top: 1em !important;
    padding-bottom: 1em !important;
    color: #000000;
  }
  td {
    font-size: 15px;
    color: #2F373E
  }
  
  .success {
    font-size: 13px;
  }

  .danger {
    font-size: 13px;
  }

</style>